import 'arrive';

import Vue from 'vue'
import App from './App'
import axios from 'axios'

import store from './store'
import router from './router'

import './plugins'

import {KEY} from '../packages/tx-products/vuex/tx-base'

Vue.config.productionTip = false;

Vue.prototype.$http = axios.create();
Vue.prototype.$httpExternal = axios.create();

if (document.getElementById('lovemap')) {
    let vm = new Vue({
        store,
        router,
        render: h => h(App),
        data() {
            return {
                env: lovemap.vue_env,
                template: null
            }
        },
        watch: {
            template(newValue, oldValue) {
                // this.setTemplate(newValue)
                console.log(oldValue)
            }
        },
        methods: {
            setTemplate(templateName, reset = false, object = false) {
                this.template = templateName
                if (templateName) {
                    this.$router.push({name: `${templateName}-index`});
                } else {
                    this.$router.push({name: `no-template`});
                }

                if (reset) {
                    this.reloadDefaultState(object);
                }
            },
            reloadDefaultState(templateData) {
                let template = this.template;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$store.commit(`${template}/reset`, templateData)
                    }, 1000)
                })
            }
        },
        computed: {
            lovemap() {
                let config = {};
                if (this.env !== 'renderer') {
                    config = lovemap
                } else {
                    config = {
                        ...lovemap,
                    }
                }
                return config
            }
        }
    });

    let template = window.lovemap?.templateName || window.mapData?.template || (!window.mapData ? 'lovemap' : false);

    vm.setTemplate(template, true, window[KEY])
    vm.$mount('#lovemap');
}
